<template>
  <div class="editBox">
    <div class="titleB">
      <div :style="[color ? {color} : {color: 'var(--color-pri)'}]">{{label}}</div>
      <EditBtn :style="{marginLeft: 'auto'}" v-if="!edit" @click="$emit('edit', true)" :bg="color"/>
    </div>
    <div class="containerB" v-if="!edit">
      <slot/>
    </div>
    <div class="containerB" v-else>
      <slot name="edit"/>
      <Btns @cancel="$emit('edit', false)" @save="$emit('save')"/>
    </div>
  </div>
</template>

<script>
import Btns from '../../components/btn/btns.vue'
import EditBtn from '../../components/btn/edit.vue'
export default {
  props: ['label', 'color', 'edit'],
  components: { EditBtn, Btns }

}
</script>

<style lang="scss" scoped>
.titleB {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 25px;
  letter-spacing: .1em;
  margin-bottom: 28px;
}
.containerB {
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-bottom: 57px;
}
.editBox {
  margin-bottom: 26px;
}
</style>
